<template>
  <div class="content">
    <div :class="{'shade_box' :show_shade==true}">
      <div class="msg_box" v-if="show_shade==true">
        <div class="msg">
          <div class="title">{{pet.msg_title}}</div>
          <p>{{pet.msg_content}}</p>
          <div v-if="show_msg==1">
            <img :src="pet.pet.pet_image" class="pet" alt />
            <div class="pet_name">{{pet.pet.pet_name}}</div>
          </div>
          <div v-else>
            <div class="title_two">登录有礼物</div>
            <p>
              入驻人数超过1000000(十万）啦！感谢同学的支持与
              热爱！特地准备了一份庆祝礼物，请及时在消息内领
              取哦！
            </p>
            <div class="title_three">附件奖励</div>
            <div class="goods_box">
              <div class="goods_item"></div>
            </div>
          </div>
          <img src="../assets/images/take_btn.png" class="take_btn" @click="take_btn" alt />
        </div>
      </div>
      <div v-else>
        <div class="back_box">
          <img src="../assets/images/back.png" class="back" alt @click="goBack()" />
        </div>
        <div class="pet" @click="gopet">
          <img src="../assets/images/pet.png" alt />
        </div>
        <div class="goods_shelf">
          <img src="../assets/images/chat.png" class="chat" alt @click="goinfo" />
          <span v-if="show_message" class="unread_message">{{message_num}}</span>
          <img src="../assets/images/backpack.png" class="backpack" alt @click="goknapsack" />
        </div>

        <div class="competency_matrix" @click="go_online_class"></div>
        <div class="online_class" @click="go_matrix"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      width: 100 + "%",
      show_shade: false,
      show_msg: 1,
      //首次登录宠物数据
      pet: "",
      info: "",
      pet_info: "",
      //未读消息数量
      message_num: "",
      //显示未读数量
      show_message: false
    };
  },
  created() {
    this.getParams();
    this.getinfo();
    this.getInfo();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    //设置
    goset() {
      this.$router.push({
        name: "set" //按照配的路由中的name跳转
      });
    },
    //消息
    goinfo() {
      this.$router.replace("/info");
    },
    //背包
    goknapsack() {
      this.$router.replace("/knapsack");
    },
    //宠物
    gopet() {
      this.$router.replace("/pet");
    },
    //开心收下
    take_btn() {
      this.$axios
        .post("/api/v1/msg/get", {
          id: this.pet.id
        })
        .then(res => {
          this.$msg.success(res.data.message);
          this.show_shade = false;
        });
    },
    //在线课堂
    go_online_class() {
      this.$router.push({
        name: "online"
      });
    },
    //在线测评
    go_online_assessment() {
      this.$router.push({
        name: "online_assessment"
      });
    },
    //能力矩阵
    go_matrix() {
      this.$router.push({
        name: "matrix"
      });
    },
    //获取首次登录获得的奖励
    getParams() {
      var routerParams = this.$route.query.alert;
      // console.log('111');
      // console.log(routerParams);
      if (routerParams) {
        this.pet = routerParams;
        //只有宠物的消息弹出
        if (this.pet.pet) {
          this.show_shade = true;
        }
      }
    },
    //获取个人信息
    getinfo() {
      this.$axios.get("/api/v1/user/info").then(res => {
        this.info = res.data.data;
        this.width = res.data.data.pet.empirical + "%";
        this.pet_info = res.data.data.pet;
      });
    },
    //获取未读消息
    getInfo() {
      this.$axios.get("/api/v1/msg/getunreadcount").then(res => {
        if (res.data.data) {
          this.message_num = res.data.data;
          this.show_message = true;
        } else {
          this.show_message = false;
          return;
        }
      });
    }
  },
  watch: {
    $router: "getParams"
  },
  mounted() {}
};
</script>

<style scoped>
.back_box {
  width: 0.44rem;
  height: 0.7rem;
  position: absolute;
  top: 0.17rem;
  left: 0.54rem;
  text-align: center;
  font-size: 0.16rem;
  font-family: "Normal";
  font-weight: bold;
  color: #ffd545;
}
.back {
  width: 0.44rem;
  height: 0.45rem;
}
.unread_message {
  display: inline-block;
  width: 0.2rem;
  height: 0.2rem;
  background-color: red;
  border-radius: 50%;
  position: absolute;
  top: -0.2rem;
  left: 1.19rem;
  text-align: center;
  line-height: 0.2rem;
  color: #fff;
  font-size: 0.12rem;
  font-family: "Normal";
}
.content {
  max-width: 10rem;
  height: 100vh;
  background: url("../assets/images/home_bgc.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
  overflow: hidden;
}
.shade_box {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}
.pet {
  width: 1.39rem;
  height: 1.47rem;
  position: absolute;
  bottom: 0.11rem;
  left: 0.15rem;
}
.pet img {
  width: 100%;
  height: 100%;
}
.goods_shelf {
  width: 2.7rem;
  height: 0.68rem;
  position: absolute;
  bottom: 0;
  right: 0;
  background: url("../assets/images/goods_shelf.png") no-repeat;
  background-size: 100% 100%;
}
.chat {
  width: 0.67rem;
  height: 0.84rem;
  position: relative;
  top: -0.37rem;
  left: 0.66rem;
}
.backpack {
  width: 0.53rem;
  height: 0.8rem;
  position: relative;
  top: -0.37rem;
  right: -1rem;
}
.set {
  width: 0.98rem;
  height: 0.92rem;
  position: absolute;
  top: 0;
  right: 0.25rem;
}
.set img {
  width: 100%;
  height: 100%;
}
.user {
  width: 2.87rem;
  height: 0.7rem;
  background-color: rgba(152, 152, 152, 0.2);
  position: absolute;
  top: 0.14rem;
  left: 0.33rem;
  border-radius: 0.05rem;
}
.header {
  width: 0.6rem;
  height: 0.6rem;
  position: absolute;
  top: 50%;
  left: 0.06rem;
  transform: translate(0, -50%);
  background: url("../assets/images/header_bgc.png") no-repeat;
  background-size: 100% 100%;
}
.header img {
  width: 0.52rem;
  height: 0.52rem;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.name {
  position: absolute;
  top: 0.1rem;
  left: 0.72rem;
  color: #168ae5;
  font-size: 0.21rem;
  font-family: "Medium";
  font-weight: 600;
  /* -webkit-text-stroke: 0.002rem #000 ; */
}
.grade {
  display: inline-block;
  position: relative;
  top: 0.4rem;
  left: 0.73rem;
  color: #fff;
  font-size: 0.16rem;
  font-family: "Normal";
  /* -webkit-text-stroke: 0.2px #000; */
}
.progress_bar {
  display: inline-block;
  width: 1.43rem;
  height: 0.14rem;
  background: url("../assets/images/progress_bar.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
  top: 0.41rem;
  right: -0.75rem;
}
.schedule {
  height: 70%;
  position: absolute;
  top: 50%;
  left: 0rem;
  transform: translate(0, -50%);
  border-radius: 0.07rem;
  background-image: linear-gradient(to right, #1b86e3, #42baeb);
  text-align: center;
  /* line-height: 100%; */
  color: #fff;
  /* font-size: 0.01rem; */
}
/* .function_box {
    width: 75%;
    height: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    display: flex;
    justify-content: space-around;
} */
.competency_matrix {
  width: 2.7rem;
  height: 2.58rem;
  position: absolute;
  top: 50%;
  left: 2.01rem;
  transform: translate(0, -47%);
  background: url("../assets/images/online_class.png") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}
.online_class {
  width: 2.7rem;
  height: 2.46rem;
  position: absolute;
  top: 50%;
  right: 2.02rem;
  transform: translate(0, -42%);
  background: url("../assets/images/competency_matrix.png") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}
/* .Online_assessment {
    width: 1.15rem;
    height: 1.56rem;
    position: absolute;
    top: 50%;
    right: 1.02rem;
    transform: translate(0,-60%);
    background: url('../assets/images/Online_assessment.png') no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
} */
.msg_box {
  width: 4.8rem;
  height: 4.29rem;
  background: url("../assets/images/msg_box.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.msg {
  width: 80%;
  height: 80%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.msg .title {
  font-size: 0.21rem;
  font-family: "Medium";
  color: #fdea77;
  font-weight: bold;
  -webkit-text-stroke: 0.01rem #000;
  text-align: center;
  background: linear-gradient(#fce98f, #e7ab42);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.msg .title_two {
  font-size: 0.14rem;
  font-family: "Medium";
  color: #fdea77;
  font-weight: bold;
  -webkit-text-stroke: 0.01rem #000;
  background: linear-gradient(#fce98f, #e7ab42);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-top: 0.33rem;
}
.msg p {
  margin-top: 0.14rem;
  color: #fff;
  font-size: 0.16rem;
  font-family: "Normal";
  text-align: center;
}
.msg .title_three {
  font-size: 0.16rem;
  font-family: "Normal";
  color: #fbe78d;
}
.msg .goods_box {
  width: 100%;
  height: auto;
  margin-top: 0.17rem;
}
.goods_item {
  width: 0.65rem;
  height: 0.67rem;
  background: url("../assets/images/goods_bgc.png") no-repeat;
  background-size: 100% 100%;
}
.msg .take_btn {
  width: 1.14rem;
  height: 0.49rem;
  position: absolute;
  bottom: 0rem;
  left: 50%;
  transform: translate(-50%, 0);
}
.msg .pet {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
}
.pet_name {
  position: absolute;
  bottom: 0.5rem;
  left: 50%;
  transform: translate(-50%, 0);
  font-size: 0.17rem;
  font-family: "Normal";
  color: #fce98f;
}
.exp_home {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 0.1rem;
  font-family: "Normal";
}
</style>